// extracted by mini-css-extract-plugin
export default {"basicInfoDiv":"validation_basicInfoDiv__OwLki","basicInfoTitle":"validation_basicInfoTitle__Skhjq"};